import moment from 'moment-timezone'

function getTimes(t) {
  return Number(String(t || '').replace(':', '')) // "06:30" -> 630, "24:30" -> 2430
}

function toMinutes(t) {
  const num = getTimes(t)
  const h = Math.floor(num / 100)
  const m = num % 100
  return h * 60 + m
}

function isValidDay(dayObj) {
  return !!(dayObj && dayObj.available && Array.isArray(dayObj.time))
}

/**
 * 1. 단일 구간에서 to < from 은 입력단 validation 으로 불가능
 * 2. to === 24:00 은 당일 종료
 * 3. to > 24:00 (24:10 ~ 24:50) 은 다음날로 일부 연장
 * 4. 여러 구간은 입력 순서를 그대로 해석
 *    뒤 구간의 from 이 앞 구간의 from 보다 작아지면 다음날(carry)로 본다
 * 5. carry 는 누적된다
 */
function buildResolvedRanges(availableTime) {
  const ranges = []

  availableTime.forEach((dayObj, baseDayIndex) => {
    if (!isValidDay(dayObj)) return

    let carryDay = 0
    let prevFromNum = null

    dayObj.time.forEach(({ from, to }, index) => {
      const fromNum = getTimes(from)
      const toNum = getTimes(to)

      // 여러 구간에서 시작 시간이 뒤로 되돌아가면 익일로 해석
      if (index > 0 && prevFromNum !== null && fromNum < prevFromNum) {
        carryDay += 1
      }

      const actualDayIndex = (baseDayIndex + carryDay) % 7
      const fromMin = toMinutes(from)
      const toMinRaw = toMinutes(to)

      // 24:10 ~ 24:50 같은 명시적 익일 연장
      if (toNum > 2400) {
        // 예: 16:00 ~ 24:30
        ranges.push({
          dayIndex: actualDayIndex,
          startMin: fromMin,
          endMin: 1439
        })

        ranges.push({
          dayIndex: (actualDayIndex + 1) % 7,
          startMin: 0,
          endMin: toMinRaw - 1440
        })
      } else {
        // 일반 same-day, 24:00은 당일 23:59로 처리
        ranges.push({
          dayIndex: actualDayIndex,
          startMin: fromMin,
          endMin: toNum === 2400 ? 1439 : toMinRaw
        })
      }

      prevFromNum = fromNum
    })
  })

  return ranges
}

/**
 * availableTime: [{ id:'mon', available:true, time:[{from,to}] }, ...]
 * nowMoment: moment()
 */
export function isAvailableNow(availableTime, nowMoment) {
  if (!Array.isArray(availableTime) || !nowMoment || !moment.isMoment(nowMoment)) {
    return false
  }

  const nowDayIndex = nowMoment.isoWeekday() - 1 // mon=0 ... sun=6
  const nowMin = nowMoment.hours() * 60 + nowMoment.minutes()

  const ranges = buildResolvedRanges(availableTime)

  return ranges.some(range => {
    return (
      range.dayIndex === nowDayIndex &&
      nowMin >= range.startMin &&
      nowMin <= range.endMin
    )
  })
}